export default function messagesES({ type = "", payload = {}, msg = "" }) {
  const form = {
    salesforce_registration_failed: () => `MessageFailed.salesforce_registration_failed`,
    application_error: () => `MessageFailed.unknown_error`,
    salesforce_api_error: () => `MessageFailed.salesforce_api_error`,
    invalid_form_data: () => `MessageFailed.invalid_form_data`,
    invalid_form_type: () => `MessageFailed.invalid_form_type`,
  };

  const messages = {
    ...form,
  };

  return type && messages[type] ? messages[type](payload) : msg;
}
